import { globalStyObj } from '@/assets/packageAssets/allStyleConfigs/a-global-cfg.js'

import { echoStyObj } from '@/assets/packageAssets/allStyleConfigs/echo.cfg.js'
import { joychatStyObj } from '@/assets/packageAssets/allStyleConfigs/joychat.cfg.js'
import { kikoStyObj } from '@/assets/packageAssets/allStyleConfigs/kiko.cfg.js'
import { vavaStyObj } from '@/assets/packageAssets/allStyleConfigs/vava.cfg.js'
import { vibeoStyObj } from '@/assets/packageAssets/allStyleConfigs/vibeo.cfg.js'

// 包变量
const styObj = {
  default: {
    ...vibeoStyObj,
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  },
  echo: {
    ...echoStyObj,
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  },
  joychat: {
    ...joychatStyObj,
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  },
  kiko: {
    ...kikoStyObj,
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  },
  vava: {
    ...vavaStyObj,
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  },
  vibeo: {
    ...vibeoStyObj,
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return { ...globalStyObj, ...styObj[this.packageName] }
        }
        // 未配置
        else {
          return { ...globalStyObj, ...styObj['default'] }
        }
      }
      return {}
    }
  }
}
